import { render, staticRenderFns } from "./GenreDetails.vue?vue&type=template&id=15e2d440&scoped=true"
import script from "./GenreDetails.vue?vue&type=script&lang=js"
export * from "./GenreDetails.vue?vue&type=script&lang=js"
import style0 from "./GenreDetails.vue?vue&type=style&index=0&id=15e2d440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e2d440",
  null
  
)

export default component.exports